// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1jFag","header":"ReportDetails_header__3-RO6","title":"ReportDetails_title__2ofJj","left":"ReportDetails_left__Yp3kM"};